import React from 'react';
import Icon from '../../../components/AppIcon';

const VenueTypeFilters = ({ selectedTypes, onTypeToggle }) => {
  const venueTypes = [
    { id: 'cafe', label: 'Cafe', icon: 'Coffee', color: 'bg-amber-500/10 text-amber-700 dark:text-amber-400' },
    { id: 'restaurant', label: 'Restaurant', icon: 'UtensilsCrossed', color: 'bg-orange-500/10 text-orange-700 dark:text-orange-400' },
    { id: 'library', label: 'Library', icon: 'BookOpen', color: 'bg-blue-500/10 text-blue-700 dark:text-blue-400' },
    { id: 'park', label: 'Park', icon: 'Trees', color: 'bg-green-500/10 text-green-700 dark:text-green-400' },
    { id: 'dog_park', label: 'Dog Park', icon: 'Dog', color: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400' },
    { id: 'gym', label: 'Gym', icon: 'Dumbbell', color: 'bg-red-500/10 text-red-700 dark:text-red-400' },
    { id: 'shopping', label: 'Shopping', icon: 'ShoppingBag', color: 'bg-purple-500/10 text-purple-700 dark:text-purple-400' },
    { id: 'bar', label: 'Bar', icon: 'Wine', color: 'bg-pink-500/10 text-pink-700 dark:text-pink-400' }
  ];

  const isSelected = (typeId) => selectedTypes?.includes(typeId);

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 lg:p-8">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-accent/10 rounded-lg">
          <Icon name="Filter" size={20} className="text-accent" />
        </div>
        <div>
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground">
            Venue Types
          </h3>
          <p className="caption text-muted-foreground">
            Select one or more categories
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {venueTypes?.map((type) => (
          <button
            key={type?.id}
            onClick={() => onTypeToggle(type?.id)}
            className={`
              flex flex-col items-center gap-2 p-3 md:p-4 rounded-lg border-2 transition-smooth hover-lift active-press
              focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3
              ${isSelected(type?.id)
                ? 'border-primary bg-primary/5' :'border-border bg-background hover:bg-muted'
              }
            `}
            aria-pressed={isSelected(type?.id)}
            aria-label={`${isSelected(type?.id) ? 'Deselect' : 'Select'} ${type?.label}`}
          >
            <div className={`
              flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-lg
              ${isSelected(type?.id) ? 'bg-primary/10' : type?.color}
            `}>
              <Icon 
                name={type?.icon} 
                size={24} 
                className={isSelected(type?.id) ? 'text-primary' : ''} 
              />
            </div>
            <span className={`
              text-xs md:text-sm font-medium text-center
              ${isSelected(type?.id) ? 'text-primary' : 'text-foreground'}
            `}>
              {type?.label}
            </span>
            {isSelected(type?.id) && (
              <div className="absolute top-2 right-2 flex items-center justify-center w-5 h-5 bg-primary rounded-full">
                <Icon name="Check" size={12} className="text-primary-foreground" />
              </div>
            )}
          </button>
        ))}
      </div>
      {selectedTypes?.length > 0 && (
        <div className="mt-4 md:mt-6 flex flex-wrap items-center gap-2">
          <span className="caption text-muted-foreground">Selected:</span>
          {selectedTypes?.map((typeId) => {
            const type = venueTypes?.find(t => t?.id === typeId);
            return (
              <div
                key={typeId}
                className="flex items-center gap-2 px-3 py-1.5 bg-primary/10 text-primary rounded-full text-xs md:text-sm font-medium"
              >
                <Icon name={type?.icon} size={14} />
                <span>{type?.label}</span>
                <button
                  onClick={() => onTypeToggle(typeId)}
                  className="hover:bg-primary/20 rounded-full p-0.5 transition-smooth"
                  aria-label={`Remove ${type?.label}`}
                >
                  <Icon name="X" size={12} />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default VenueTypeFilters;